export const CALENDAR_CHANGED_EVENT = 'calendar.changed';

export function concernsCalendar(event: string, payload: unknown, providerIds: ReadonlySet<string>): boolean {
  if (event === CALENDAR_CHANGED_EVENT) return true;
  const doctorId = (payload as { doctorId?: unknown } | null)?.doctorId;
  return typeof doctorId !== 'string' || providerIds.size === 0 || providerIds.has(doctorId);
}
